import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {elementsInLoading, stockAssDetailsNotListedFilters, stockAssDetailsSummaryFilters} from "../@signals";


export default function useStockAssDetailsTableDetails() {

    const data = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) {
            stockAssDetailsNotListedFilters.value = {}
            data.value = []
            isLoading.value = true
            postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/table`, { ...stockAssDetailsSummaryFilters.value })
                .then(res => {
                    data.value = res
                    isLoading.value = false
                })
                .catch(() => {
                    isLoading.value = false
                    isSystemBusy.value = true
                })
        }
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (isLoading.value)
            elementsInLoading.value = [...elementsInLoading.value, 'detailsTable']
        else
            elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'detailsTable')
    }, [isLoading.value])

    return {
        tableData: data.value,
        isLoading: isLoading.value
    }
}